<template>
  <div
    id="menuPLV"
    :class="[plvOuverture, 'menu' + plvAffichage]"
    @mouseleave="handleMouseLeave"
  >
    <component
      :is="params.LIEN_RACINE_MENU && params.LIEN_RACINE_MENU !== '' ? 'a' : 'div'"
      v-if="plvAffichage === 'VT' && label"
      id="showCatalogMenu"
      :href="(params.LIEN_RACINE_MENU && params.LIEN_RACINE_MENU !== '') ? params.LIEN_RACINE_MENU : null"
      :class="[
        'flex-fJcenter-fAcenter navSite',
        {
          'navSiteHover': isMenuVisible,
          'navSiteActive': isCataloguePage
        }
      ]"
      @click.stop="toggleMenu"
      @mouseenter="handleBtnMouseEnter"
      v-html="label"
    />
    <div
      v-show="plvAffichage === 'HZ'|| isMenuVisible || isMobileOpen"
      id="catalogMenu"
      :class="[
        'catalogMenu' + plvAffichage,
        { 'is-open': isMenuVisible, 'mobile-open': isMobileOpen }
      ]"
    >
      <div
        :class="plvAffichage === 'HZ' ? 'flex-col-fJstart-fAstart' : 'flex-fJstart-fAstretch'"
      >
        <span
          v-if="plvAffichage === 'VT' && plvOuverture === 'clic'"
          class="icon-cross pixel_32"
          @click="closeMenu"
        />
        <div
          class="menuProduit_categories"
          :class="plvAffichage === 'HZ' ? 'flex-fJbetween-fAcenter' : ''"
        >
          <component
            :is="(plvOuverture === 'clic' && !isMobile) ? 'div' : 'a'"
            v-for="activite in planVente"
            :key="activite.CODE"
            :class="getActiviteClasses(activite)"
            :style="getActiviteStyles(activite)"
            :href="(plvOuverture === 'clic' && !isMobile) ? null : activite.LIEN"
            @mouseenter="handleMouseOver(activite.CODE)"
            @click="handleMenuClick($event, activite.CODE)"
          >
            <img
              v-if="activite.OPTIONS.SHOW_PICTO_MENU && activite.OPTIONS.PICTO"
              :src="activite.OPTIONS.PICTO"
            >
            <span>{{ formatLibelle(activite.LIBELLE) }}</span>
          </component>
        </div>
        <div
          v-if="menus"
          class="menuProduit_activites"
          v-show="isMenuVisible"
        >
          <div
            class="menuProduit_activite"
            :class="{ 'content' : (plvAffichage === 'HZ') }"
          >
            <span
              v-if="plvAffichage === 'HZ' && plvOuverture === 'clic'"
              class="icon-cross pixel_32"
              @click="closeMenu"
            />
            <menu-item
              v-for="child in menus.data.PLAN_VENTE"
              :key="child.CODE"
              :item="child"
              :niveau-max="niveauMax"
              :current-level="1"
              :plv-casse="plvCasse"
            />
          </div>
        </div>

        <div
          v-else-if="fetching"
          class="menuProduit_activites"
        >
          <div class="menuProduit_empty">Chargement...</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import MenuItem from './planVente/MenuItem.vue'

const STORAGE_KEY = 'openweb-menu'
export default {
  name: 'TheMenuCategories',
  components: {
    MenuItem
  },
  props: {
    initialPlanVente: {
      type: Array,
      default: () => []
    },
    menu: {
      type: Object,
      default: () => ({
        PLAN_VENTE: [],
        HIERARCHIE: [{ CODE: '' }]
      })
    },
    params: {
      type: Object,
      default: () => ({
        CASSE: '',
        PLAN_VENTE_AFFICHAGE: 'VT',
        MENU_TYPE_OUVERTURE: '',
        LIEN_RACINE_MENU: '',
        NIVEAU_MAX: '',
        CURRENT_PATH: '',
        CODE_DEPOT: '',
        xmlDataVersion: ''
      })
    },
    label: {
      type: String,
      default: ''
    },
    cacheKey: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      menus: null,
      currentActiviteCode: null,
      planVente: this.menu.PLAN_VENTE || [],
      currentCode: (this.menu.HIERARCHIE && this.menu.HIERARCHIE[0]) ? this.menu.HIERARCHIE[0].CODE : '',
      firstCode: (this.menu.PLAN_VENTE && this.menu.PLAN_VENTE[0]) ? this.menu.PLAN_VENTE[0].CODE : '',
      niveauMax: Number(this.params.NIVEAU_MAX) || 0,
      plvCasse: this.params.CASSE || '',
      plvAffichage: (this.params.PLAN_VENTE_AFFICHAGE || '').toUpperCase(),
      plvOuverture: this.params.MENU_TYPE_OUVERTURE,
      isMenuVisible: false,
      isMobileOpen: false,
      isMobile: false,
      fetching: false,
      timeout: null
    }
  },
  mounted() {
    this.checkCacheVersion()
    const defaultCode = this.currentCode || this.firstCode
    if (defaultCode) {
      this.loadSubMenu(defaultCode)
    }
    window.addEventListener('toggle-catalog-mobile', (e) => {
      this.isMenuVisible = e.detail.open
      this.isMobileOpen = e.detail.open
      this.isMobile = window.innerWidth <= 939
    })
    document.addEventListener('click', this.handleOutsideClick)
  },
  beforeDestroy() {
    window.removeEventListener('toggle-catalog-mobile')
    document.removeEventListener('click', this.handleOutsideClick)
  },
  methods: {
    toggleMenu() {
      this.isMenuVisible = !this.isMenuVisible
      if (this.isMenuVisible && this.firstCode && !this.currentActiviteCode) {
        this.loadSubMenu(this.firstCode)
      }
    },
    closeMenu() {
      this.isMenuVisible = false
    },
    handleBtnMouseEnter() {
      if (this.plvOuverture === 'survol') {
        clearTimeout(this.timeout)
        this.isMenuVisible = true
        if (this.firstCode && !this.currentActiviteCode) {
          this.loadSubMenu(this.firstCode)
        }
      }
    },
    handleMouseOver(code) {
      if (!this.isMobile && this.plvOuverture === 'survol') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.loadSubMenu(code)
          if (this.plvAffichage === 'HZ') {
            this.isMenuVisible = true
          }
        }, 50)
      }
    },
    handleMouseLeave() {
      if (!this.isMobile && this.plvOuverture === 'survol') {
        this.timeout = setTimeout(() => {
          this.closeMenu()
        }, 200)
      }
    },
    handleMenuClick(event, code) {
      if (!this.isMobile && this.plvOuverture === 'clic') {
        if (this.currentActiviteCode !== code) {
          event.preventDefault()
          this.loadSubMenu(code)
          this.isMenuVisible = true
        }
      }
    },
    handleOutsideClick(event) {
      if (this.isMenuVisible && this.$el && !this.$el.contains(event.target)) {
        this.closeMenu()
      }
    },
    checkCacheVersion() {
      const currentVersion = String(this.params.xmlDataVersion)
      const oldVersion = window.localStorage.getItem('openweb-menu-version')
      if (oldVersion !== currentVersion) {
        Object.keys(window.localStorage).forEach(key => {
          if (key.startsWith('openweb-menu-')) {
            window.localStorage.removeItem(key)
          }
        })
        window.localStorage.setItem('openweb-menu-version', currentVersion)
        window.localStorage.setItem('openweb-menu-cachekey', String(this.cacheKey))
      }
    },
    async loadSubMenu(code) {
      if (this.currentActiviteCode === code || this.fetching) return
      this.currentActiviteCode = code
      const depotId = this.params.CODE_DEPOT && this.params.CODE_DEPOT !== ''
        ? this.params.CODE_DEPOT
        : 'global'
      const storageKey = `openweb-menu-${depotId}-${code}`
      const cachedRaw = window.localStorage.getItem(storageKey)
      if (cachedRaw) {
        try {
          const cachedData = JSON.parse(cachedRaw)
          if (cachedData &&
            cachedData.data &&
            Array.isArray(cachedData.data.PLAN_VENTE) &&
            cachedData.data.PLAN_VENTE.length > 0) {
              this.menus = cachedData
              return
          } else {
            window.localStorage.removeItem(storageKey)
          }
        } catch (e) {
          window.localStorage.removeItem(storageKey)
        }
      }
      this.fetching = true
      this.menus = null

      try {
        const response = await axios.get('/submenu/' + code)
        if (this.currentActiviteCode === code) {
          this.menus = response.data
          if (this.menus.data &&
            this.menus.data.PLAN_VENTE &&
            this.menus.data.PLAN_VENTE.length > 0) {
              window.localStorage.setItem(storageKey, JSON.stringify(response.data))
            }
        }
      } catch (e) {
        console.error('Erreur chargement sous-menu:', e)
      } finally {
        this.fetching = false
      }
    },
    getActiviteClasses(activite) {
      return {
        'menu': true,
        'icon-arrow-right': this.plvAffichage === 'VT' || this.isMobileOpen,
        'flex-fJcenter-fAcenter': this.plvAffichage === 'HZ',
        'flex-fJbetween-fAcenter': this.isMobileOpen,
        'menuActive': this.currentCode === activite.CODE,
        'menuHover': this.currentActiviteCode === activite.CODE,
        'withPicto': activite.OPTIONS.SHOW_PICTO_MENU && activite.OPTIONS.PICTO
      }
    },
    getActiviteStyles(activite) {
      const opt = activite.OPTIONS || {}
      return {
        borderLeftColor: opt.BORDER_COLOR || '',
        backgroundColor: opt.BACKGROUND_COLOR || '',
        color: opt.FONT_COLOR || ''
      }
    },
    formatLibelle(libelle) {
      if (this.plvCasse === 'maj') return libelle.toUpperCase()
      if (this.plvCasse === 'min') return libelle.charAt(0).toUpperCase() + libelle.slice(1).toLowerCase()
      return libelle
    }
  },
  computed: {
    isCataloguePage() {
      const path = this.params.CURRENT_PATH || ''
      return path.includes('/produit/') || path.includes('/categorie/')
    }
  }
}
</script>
